import { $, $$, body } from "@utils/dom";
import { on, off } from "@utils/listener";
import { lerp } from "@utils/math";

class MouseHoverProgress {
  constructor(el, emitter) {
    this.el = el;
    this.emitter = emitter;

    this._initMouseCalculation = this._initMouseCalculation.bind(this);
    this._destroyMouseCalculation = this._destroyMouseCalculation.bind(this);
    this._onRaf = this._onRaf.bind(this);

    this._calculateMousePosition = this._calculateMousePosition.bind(this);
    this._updateMouseX = this._updateMouseX.bind(this);

    this._setInitialX = this._setInitialX.bind(this);

    this.init();
  }

  init() {
    this.rect = this.el.getBoundingClientRect();
    this._x = 0;
    this.mouseX = 0;
    this.mouseY = 0;

    this._setInitialX();

    this._bindEvents();
  }
  destroy() {
    this._unbindEvents();
    this._destroyMouseCalculation();

    this.el = null;
    this.emitter = null;

    this.rect = null;
    this._x = null;
    this.mouseX = null;
    this.mouseY = null;

    this._initMouseCalculation = null;
    this._destroyMouseCalculation = null;
    this._onRaf = null;

    this._calculateMousePosition = null;
    this._updateMouseX = null;

    this._setInitialX = null;
  }

  start() {}
  stop() {}

  _bindEvents() {
    on(this.el, 'mouseenter', this._initMouseCalculation);
    on(this.el, 'mouseleave', this._destroyMouseCalculation);
  }
  _unbindEvents() {
    off(this.el, 'mouseenter', this._initMouseCalculation);
    off(this.el, 'mouseleave', this._destroyMouseCalculation);
  }

  _setInitialX(){
    if(this.el.dataset.mouseHoverProgress){
      this._x = parseFloat(this.el.dataset.mouseHoverProgress);
    }
    this.el.style.setProperty('--mouse-x-progress', this._x);
  }

  _initMouseCalculation(){
    on(window, "mousemove", this._calculateMousePosition);
    this._raf = requestAnimationFrame(this._onRaf);
  }

  _destroyMouseCalculation(){
    off(window, "mousemove", this._calculateMousePosition);
    if (this._raf) cancelAnimationFrame(this._raf);
    this._raf = null;
  }

  _calculateMousePosition(event){
    this.mouseX = event.clientX;
    this.mouseY = event.clientY;
  }

  _updateMouseX(mouseX){
    const progress = Math.min(Math.max(((mouseX-this.rect.left)/this.rect.width), 0), 1);

    this._x = lerp(this._x, progress, 0.025);
    this.el.style.setProperty('--mouse-x-progress', this._x);
  }

  _onRaf(){
    this._raf = requestAnimationFrame(this._onRaf);

    this._updateMouseX(this.mouseX);
  }

}

export default MouseHoverProgress;
